import { TuiButtonModule } from '@taiga-ui/core';
import { Store } from '@ngrx/store';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { authActions } from '@iss/wo-common/ngrx';

@Component({
  templateUrl: './not-authorized-page.component.html',
  styleUrls: [ './not-authorized-page.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TuiButtonModule,
  ],
})
export class NotAuthorizedPageComponent {
  private readonly store = inject(Store);

  public logout(): void {
    this.store.dispatch(authActions.logout({ withRequest: true }));
  }
}
